/**
 * Replaces {name} tokens in a (possibly translated) string with values from `vars`.
 * Unmatched tokens are left intact so a typo never blanks copy. The `$` in patterns
 * like `${monthlyCharge}` is preserved — only the brace-wrapped name is replaced.
 */
export const interpolateVariables = (
  template: string,
  vars?: Record<string, string | number>
): string => {
  if (!vars) {
    return template;
  }

  return template.replace(/\{(\w+)\}/g, (match, name) =>
    Object.prototype.hasOwnProperty.call(vars, name) ? String(vars[name]) : match
  );
};
